import { useState, useEffect } from 'react';

const ContactInfo = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('contact-info');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const contactDetails = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      value: '+91 999 56 129 33',
      link: 'tel:+919995612933'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      value: 'hello@hashadz.com',
      link: 'mailto:hello@hashadz.com'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Office Address',
      value: 'Hash Creative Consultants,\nAdan\'s Plaza, Link Rd, Stadium Rd,\nbehind JLN, Janatha, Kathrikadavu,\nPalarivattom, Kochi, Kerala 682025',
      link: 'https://maps.app.goo.gl/8Kpm32rXPE2vEmz87'
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      value: 'Monday - Friday\n9:00 AM - 6:00 PM IST',
      link: null
    }
  ];

  return (
    <section id="contact-info" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Connect with Our Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Prefer to connect directly? You can find us at our office in Kochi or reach us via phone and email during business hours. We're always here to assist you.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-8">
              {contactDetails.map((detail, index) => (
                <div 
                  key={index}
                  className={`transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className="flex items-start gap-6 p-6 bg-gradient-to-r from-gray-50 to-white rounded-xl hover:shadow-lg transition-shadow duration-300">
                    <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${detail.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{detail.title}</h3>
                      {detail.link ? (
                        <a 
                          href={detail.link}
                          className="text-gray-600 hover:text-purple-600 transition-colors duration-300 whitespace-pre-line"
                          target={detail.link.startsWith('http') ? '_blank' : undefined}
                          rel={detail.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                        >
                          {detail.value}
                        </a>
                      ) : (
                        <p className="text-gray-600 whitespace-pre-line">{detail.value}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'}`}>
              <div className="bg-gray-100 rounded-xl overflow-hidden shadow-lg h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.295398051349!2d76.3030054!3d9.992439899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080d70f49cf1ad%3A0xe4bd87b56060b739!2sHash%20Adz%20Creative%20Consultants!5e0!3m2!1sen!2sin!4v1766754490119!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Hash Adz Office Location"
                ></iframe>
              </div>
              <div className="mt-6 text-center">
                <a
                  href="https://maps.app.goo.gl/8Kpm32rXPE2vEmz87"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-full hover:from-purple-700 hover:to-pink-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  <i className="ri-map-pin-line"></i>
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;